module.exports = __webpack_public_path__ + "static/media/profile-notifications.38744483.png";